<template>
    <div v-if="order && order.sendOrder">
        <div v-if="order.sendOrder.status === 'paid'">
            <Success title="Płatność została pomyślnie zakończona" subtitle="Dziękujemy za dokonanie płatności. <BR> Twoja rezerwacja została potwierdzona."/>


        </div>
  
    <div v-if="order.sendOrder.status === 'error'">
        <ContactBox />
        <h1 class="text-2xl font-semibold mb-4">Wystąpił błąd podczas przetwarzania zgłoszenia</h1>
        <p class="mb-4">Niestety, podczas przetwarzania Twojego zgłoszenia wystąpił błąd.</p>
        <p class="mb-4">Prosimy o kontakt z naszym działem obsługi klienta w celu rozwiązania problemu.</p>

    </div>

    <div v-if="order.sendOrder.status === 'new'">
        <Success />
        <h1 class="text-2xl font-semibold mb-4">Dziękujemy za zgłoszenie</h1>
        <p class="mb-4">Twoje zgłoszenie zostało przyjęte, musimy zweryfikować dostępnośc miejsc.</p>
        <p class="mb-4">Dodatkowe informacje zostały wysłane na Twój email <b>{{ order.sendOrder.details.customer.email
                }}</b></p>
    </div>

    <div v-if="order.sendOrder.status === 'confirmed'">
        <Success
            title="Dziękujemy za zgłoszenie"
            :subtitle="`Szczegóły Twojej rezerwacji zostały wysłane na <b>${order.sendOrder.details.customer.email}</b>`"
        />
    </div>

    <div v-if="order.sendOrder.status == 'pending_payment'" class="checkout-payment-container mt-6">
       
    
         <Success
         title="Dokończenie płatności" 
         subtitle="Twoje zgłoszenie zostało przyjęte, ale wymaga dokonania płatności, aby zakończyć rezerwację. 
                <p class='text-base font-semibold mt-4'>Prosimy o dokonanie płatności w ciągu 24 godzin od złożenia rezerwacji.
                <br>Po dokonaniu płatności otrzymasz potwierdzenie na podany adres e-mail.
                <br>W przypadku pytań lub problemów z płatnością, prosimy o kontakt z naszym działem obsługi klienta.</p>"
         :button-text="`Zapłać ${order.sendOrder.details.payment.method}`"
         :link="resolvedPaymentLink"/>
    

    </div>
    </div>
    <div v-else>
        <!-- Order not loaded yet (or missing) -->
    </div>


</template>

<script>
import Success from '@/components/Success.vue';
import ContactBox from '@/components/ContactBox.vue';
import rpAPI from '@shared/service/rpAPI';

export default {
    components: { Success, ContactBox },
    name: 'CheckoutPayment',
    props: {
        order: {
            type: Object,
            required: false
        },
        onCancel: {
            type: Function,
            required: false
        },
        onNext: {
            type: Function,
            required: false
        },
        paymentLink: {
            type: String,
            required: false
        }
    },
    computed: {
        resolvedPaymentLink() {
            return this.paymentLink;
        }
    },
    mounted() {
  
        const rawLink = this.resolvedPaymentLink;
        if (!rawLink) return;

        let url;
        try {
            url = new URL(rawLink);
        } catch (e) {
            console.error('Invalid payment link', rawLink, e);
            return;
        }

        // Safety: block javascript:, data:, etc. (encoding the whole URL is not a good fix for this)
        if (url.protocol !== 'https:' && url.protocol !== 'http:') {
            console.warn('Blocked non-http(s) payment link', url.toString());
            return;
        }

        rpAPI.clearStorageItem('order', true);
        window.location.assign(url.toString());
    }
}

</script>